import { create } from "zustand";

const useMoveSparksModalStore = create((set) => ({
  isOpen: false,
  fromSpace: null,
  setIsOpen: (isOpen, space = null) => set({ isOpen, fromSpace: space }),
}));

export default useMoveSparksModalStore;
